import moment from 'moment';

export const getTimeParams = () => {
  return {
    tt: parseInt(moment().format('HHmm')),
  };
};
